import {writable} from 'svelte/store'

// export const itemStates = writable({})
// export const generalStates = writable({isShooting: true})
// export const itemIds = writable([])
export const imgCount = writable(0)
export const sharedStates = writable({})
